import { render, staticRenderFns } from "./invoicing.vue?vue&type=template&id=9db66a8a&scoped=true"
import script from "./invoicing.vue?vue&type=script&lang=js"
export * from "./invoicing.vue?vue&type=script&lang=js"
import style0 from "./invoicing.vue?vue&type=style&index=0&id=9db66a8a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9db66a8a",
  null
  
)

export default component.exports